import React, { FC } from 'react'
import { DialogBoxWrapper, ContentBox, DialogBox, FileDownloadWrapper } from '../GeneralMessage.styles'
import Font from 'src/components/Core/Typography/Font/Font'
import Flex from 'src/components/Layout/Flex/Flex'
import { getBaseApiHost } from 'src/components/Core/Utils/url_constants'
import useFetch from 'src/components/Core/Hooks/useFetch/useFetch'
import Icon from 'src/components/Core/Iconography/Icon/Icon'
import { CommentBaloonType } from './types'

const CommentBalloon: FC<CommentBaloonType> = props => {
  const { comment, applicationId } = props
  const { sendRequest } = useFetch()

  const downloadFile = ({commentId, fileId}: {commentId: number, fileId: number}) => {
    const download = (data: string) => {
      const link = document.createElement('a')
      // @ts-ignore
      link.setAttribute('href', data)
      link.setAttribute('download', 'downloadFile')
      document.body.appendChild(link)
      link.click()
    }
    sendRequest({
      scope: 'onboarding',
      url: import.meta.env.VITE_MOCK_DATA !== 'true'
        ? `${getBaseApiHost()}/Comments/GetFileContents?applicationId=${applicationId}&CommentId=${commentId}&Fileid=${fileId}`
        : `${window.location.origin}/mock/comments-addWithFile.json`,
      method: 'POST',
      body: {},
    },
    data => download(data)
    )
  }

  return (
    <DialogBoxWrapper maxWidth justifyContent={comment.self ? 'flex-end' : 'flex-start'}>
      <DialogBox
        flexDirection='column'
        alignItems={comment.self ? 'flex-end' : 'flex-start'}
      >
        <Flex flexDirection={comment.self ? 'row-reverse' : 'row'} gap='12px'>
          <Font margin='0 0 8px 0' bold>{comment.username}</Font>
          <Font tag='h6' margin='0 0 8px 0'>{new Date(comment.commentDateTime).toLocaleString([], {day: 'numeric', month: 'numeric', year: 'numeric'})}</Font>
        </Flex>
        <ContentBox
          flexDirection='column'
          alignItems={comment.self ? 'flex-end' : 'flex-start'}
          bgColor={comment.self ? '1' : '0'}
        >
          <Font tag='h6' margin='0 0 12px 0'>{new Date(comment.commentDateTime).toLocaleString([], {hour: '2-digit', minute: '2-digit', hour12: true}).toUpperCase()}</Font>
          <Font margin='0'>{comment.commentContent}</Font>
        </ContentBox>
        {
          comment.fileID &&
          comment.fileID !== 0
            ? <FileDownloadWrapper gap='4px' onClick={() => downloadFile({commentId: comment.commentID, fileId: comment.fileID})}>
              {comment.fileName}
              <Icon name='download' color='main' size='s'/>
            </FileDownloadWrapper>
            : null
        }
      </DialogBox>
    </DialogBoxWrapper>
  )
}

export default CommentBalloon

